// components/ThemeToggle.js
import { useThemeContext } from '../ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';
import styles from './ToggleButton.module.css'; // CSS Module for button styles

const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeContext();

  return (
    <button onClick={toggleTheme} className={styles.toggleButton}>
      {theme === 'light' ? <FaMoon className={styles.icon} /> : <FaSun className={styles.icon}/>}
    </button>
  );
};

export default ThemeToggle;
